import { Sun, Moon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useTheme } from '@/hooks/useTheme';

export default function ThemeToggle({ className = '' }) {
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'dark';
  return (
    <Button
      onClick={toggleTheme}
      data-testid="theme-toggle-button"
      variant="ghost"
      title={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
      className={`text-zinc-400 hover:text-white ${className}`}
    >
      {isDark ? <Sun className="h-5 w-5" /> : <Moon className="h-5 w-5" />}
    </Button>
  );
}
